import { useMemo, useRef, useState } from 'react';

const STORAGE_KEY = 'suite_page_size';
export const PAGE_SIZE_OPTIONS = [25, 50, 100];

const storedSize = () => {
  const saved = Number(localStorage.getItem(STORAGE_KEY));
  return PAGE_SIZE_OPTIONS.includes(saved) ? saved : 25;
};

/** Page state + offset/limit params. `resetKey` sends the user back to page 1 when filters change. */
export function usePagination(resetKey = '') {
  const [pageSize, setSizeState] = useState(storedSize);
  const [page, setPage] = useState(1);
  const lastKey = useRef(resetKey);

  if (lastKey.current !== resetKey) {
    lastKey.current = resetKey;
    if (page !== 1) setPage(1);
  }

  const setPageSize = (size) => {
    localStorage.setItem(STORAGE_KEY, String(size));
    setSizeState(size);
    setPage(1);
  };

  const offset = (page - 1) * pageSize;
  const params = useMemo(() => ({ offset, limit: pageSize }), [offset, pageSize]);

  return { page, setPage, pageSize, setPageSize, offset, params };
}
